import moment from 'moment'

import LaboratoryStudy from './LaboratoryStudy'
import useArrayUtils from 'hooks/useArrayUtils'

function LaboratoryStudies({ data }) {
    const { isArrayEmpty } = useArrayUtils()

    const labs = data.laboratoryStudies

    return (
        <>
            <h3>Lab Studies</h3>
            <table>
                <tbody>
                    {isArrayEmpty(labs) && (
                        <tr><td>No information available</td></tr>
                    )}
                    {labs.map((lab, index) => (
                        <div key={index}>
                            <tr style={{ marginTop: '13px', marginBottom: '8px', fontSize: '16px' }}>
                                {/* Leave whitespace below between the date and lab identifier text*/}
                                <th style={{ marginTop: '9px' }}>{moment(lab.observationDateTime).format('DD/MM/yyyy')}             {lab.identifier.text}</th>
                            </tr>
                            <tr>
                                <td>
                                    <LaboratoryStudy lab={lab} />
                                </td>
                            </tr>
                        </div>
                    ))}
                </tbody>
            </table>
        </>
    )
}

export default LaboratoryStudies
